import React from "react";
import { Card, CardContent, Box } from "@mui/material";
import ArchitecturalRequestTimeline from "../ArchitecturalRequestTimeline";

const MemberCard = ({ id }) => {
  return (
    <Card>
      <CardContent>
        <Box>
          <ArchitecturalRequestTimeline architectural_request_id={id} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default MemberCard;
